/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrmProjectInvitationData } from './CrmProjectInvitationData';
import {
    CrmProjectInvitationDataFromJSON,
    CrmProjectInvitationDataFromJSONTyped,
    CrmProjectInvitationDataToJSON,
    CrmProjectInvitationDataToJSONTyped,
} from './CrmProjectInvitationData';
import type { CrmProjectNoteData } from './CrmProjectNoteData';
import {
    CrmProjectNoteDataFromJSON,
    CrmProjectNoteDataFromJSONTyped,
    CrmProjectNoteDataToJSON,
    CrmProjectNoteDataToJSONTyped,
} from './CrmProjectNoteData';
import type { CrmProjectSnapshotData } from './CrmProjectSnapshotData';
import {
    CrmProjectSnapshotDataFromJSON,
    CrmProjectSnapshotDataFromJSONTyped,
    CrmProjectSnapshotDataToJSON,
    CrmProjectSnapshotDataToJSONTyped,
} from './CrmProjectSnapshotData';
import type { CrmProjectIntegrationData } from './CrmProjectIntegrationData';
import {
    CrmProjectIntegrationDataFromJSON,
    CrmProjectIntegrationDataFromJSONTyped,
    CrmProjectIntegrationDataToJSON,
    CrmProjectIntegrationDataToJSONTyped,
} from './CrmProjectIntegrationData';
import type { CrmProjectContactData } from './CrmProjectContactData';
import {
    CrmProjectContactDataFromJSON,
    CrmProjectContactDataFromJSONTyped,
    CrmProjectContactDataToJSON,
    CrmProjectContactDataToJSONTyped,
} from './CrmProjectContactData';
import type { CrmProjectSubscriptionData } from './CrmProjectSubscriptionData';
import {
    CrmProjectSubscriptionDataFromJSON,
    CrmProjectSubscriptionDataFromJSONTyped,
    CrmProjectSubscriptionDataToJSON,
    CrmProjectSubscriptionDataToJSONTyped,
} from './CrmProjectSubscriptionData';
import type { CrmProjectNotePageData } from './CrmProjectNotePageData';
import {
    CrmProjectNotePageDataFromJSON,
    CrmProjectNotePageDataFromJSONTyped,
    CrmProjectNotePageDataToJSON,
    CrmProjectNotePageDataToJSONTyped,
} from './CrmProjectNotePageData';
import type { CrmProjectBillingData } from './CrmProjectBillingData';
import {
    CrmProjectBillingDataFromJSON,
    CrmProjectBillingDataFromJSONTyped,
    CrmProjectBillingDataToJSON,
    CrmProjectBillingDataToJSONTyped,
} from './CrmProjectBillingData';
import type { CrmProjectDomainData } from './CrmProjectDomainData';
import {
    CrmProjectDomainDataFromJSON,
    CrmProjectDomainDataFromJSONTyped,
    CrmProjectDomainDataToJSON,
    CrmProjectDomainDataToJSONTyped,
} from './CrmProjectDomainData';

/**
 * 
 * @export
 * @interface CrmProjectDetailData
 */
export interface CrmProjectDetailData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectDetailData
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectDetailData
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectDetailData
     */
    logoUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectDetailData
     */
    currency?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectDetailData
     */
    projectCreatedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectDetailData
     */
    capturedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectDetailData
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectDetailData
     */
    deletedAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectDetailData
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectDetailData
     */
    archivedAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectDetailData
     */
    isArchived?: boolean;
    /**
     * 
     * @type {CrmProjectDetailDataLifecycleEnum}
     * @memberof CrmProjectDetailData
     */
    lifecycle?: CrmProjectDetailDataLifecycleEnum;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectDetailData
     */
    primaryContactUserId?: string | null;
    /**
     * 
     * @type {CrmProjectDetailDataPrimaryContactOriginEnum}
     * @memberof CrmProjectDetailData
     */
    primaryContactOrigin?: CrmProjectDetailDataPrimaryContactOriginEnum;
    /**
     * 
     * @type {CrmProjectDetailDataCrmStatusEnum}
     * @memberof CrmProjectDetailData
     */
    crmStatus?: CrmProjectDetailDataCrmStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectDetailData
     */
    nextContactAt?: Date | null;
    /**
     * 
     * @type {CrmProjectNoteData}
     * @memberof CrmProjectDetailData
     */
    latestNote?: CrmProjectNoteData | null;
    /**
     * 
     * @type {CrmProjectBillingData}
     * @memberof CrmProjectDetailData
     */
    billing?: CrmProjectBillingData | null;
    /**
     * 
     * @type {Array<CrmProjectContactData>}
     * @memberof CrmProjectDetailData
     */
    contacts?: Array<CrmProjectContactData>;
    /**
     * 
     * @type {Array<CrmProjectIntegrationData>}
     * @memberof CrmProjectDetailData
     */
    integrations?: Array<CrmProjectIntegrationData>;
    /**
     * 
     * @type {CrmProjectSubscriptionData}
     * @memberof CrmProjectDetailData
     */
    subscription?: CrmProjectSubscriptionData | null;
    /**
     * 
     * @type {CrmProjectDetailDataSubscriptionKnowledgeEnum}
     * @memberof CrmProjectDetailData
     */
    subscriptionKnowledge?: CrmProjectDetailDataSubscriptionKnowledgeEnum;
    /**
     * 
     * @type {CrmProjectSnapshotData}
     * @memberof CrmProjectDetailData
     */
    snapshot?: CrmProjectSnapshotData;
    /**
     * 
     * @type {CrmProjectNotePageData}
     * @memberof CrmProjectDetailData
     */
    notes?: CrmProjectNotePageData;
    /**
     * 
     * @type {Array<CrmProjectDomainData>}
     * @memberof CrmProjectDetailData
     */
    domains?: Array<CrmProjectDomainData>;
    /**
     * 
     * @type {CrmProjectDetailDataDomainsKnowledgeEnum}
     * @memberof CrmProjectDetailData
     */
    domainsKnowledge?: CrmProjectDetailDataDomainsKnowledgeEnum;
    /**
     * 
     * @type {Array<CrmProjectInvitationData>}
     * @memberof CrmProjectDetailData
     */
    pendingInvitations?: Array<CrmProjectInvitationData>;
    /**
     * 
     * @type {CrmProjectDetailDataInvitationsKnowledgeEnum}
     * @memberof CrmProjectDetailData
     */
    invitationsKnowledge?: CrmProjectDetailDataInvitationsKnowledgeEnum;
}


/**
 * @export
 */
export const CrmProjectDetailDataLifecycleEnum = {
    Active: 'active',
    Deleted: 'deleted'
} as const;
export type CrmProjectDetailDataLifecycleEnum = typeof CrmProjectDetailDataLifecycleEnum[keyof typeof CrmProjectDetailDataLifecycleEnum];

/**
 * @export
 */
export const CrmProjectDetailDataPrimaryContactOriginEnum = {
    Observed: 'observed',
    LegacyInferred: 'legacy_inferred',
    Manual: 'manual',
    Unknown: 'unknown'
} as const;
export type CrmProjectDetailDataPrimaryContactOriginEnum = typeof CrmProjectDetailDataPrimaryContactOriginEnum[keyof typeof CrmProjectDetailDataPrimaryContactOriginEnum];

/**
 * @export
 */
export const CrmProjectDetailDataCrmStatusEnum = {
    New: 'new',
    Contacted: 'contacted',
    NeedsHelp: 'needs_help',
    Waiting: 'waiting',
    Active: 'active',
    Churned: 'churned',
    Closed: 'closed'
} as const;
export type CrmProjectDetailDataCrmStatusEnum = typeof CrmProjectDetailDataCrmStatusEnum[keyof typeof CrmProjectDetailDataCrmStatusEnum];

/**
 * @export
 */
export const CrmProjectDetailDataSubscriptionKnowledgeEnum = {
    Known: 'known',
    Unknown: 'unknown'
} as const;
export type CrmProjectDetailDataSubscriptionKnowledgeEnum = typeof CrmProjectDetailDataSubscriptionKnowledgeEnum[keyof typeof CrmProjectDetailDataSubscriptionKnowledgeEnum];

/**
 * @export
 */
export const CrmProjectDetailDataDomainsKnowledgeEnum = {
    Known: 'known',
    Unknown: 'unknown',
    NotApplicable: 'not_applicable'
} as const;
export type CrmProjectDetailDataDomainsKnowledgeEnum = typeof CrmProjectDetailDataDomainsKnowledgeEnum[keyof typeof CrmProjectDetailDataDomainsKnowledgeEnum];

/**
 * @export
 */
export const CrmProjectDetailDataInvitationsKnowledgeEnum = {
    Known: 'known',
    Unknown: 'unknown',
    NotApplicable: 'not_applicable'
} as const;
export type CrmProjectDetailDataInvitationsKnowledgeEnum = typeof CrmProjectDetailDataInvitationsKnowledgeEnum[keyof typeof CrmProjectDetailDataInvitationsKnowledgeEnum];


/**
 * Check if a given object implements the CrmProjectDetailData interface.
 */
export function instanceOfCrmProjectDetailData(value: object): value is CrmProjectDetailData {
    return true;
}

export function CrmProjectDetailDataFromJSON(json: any): CrmProjectDetailData {
    return CrmProjectDetailDataFromJSONTyped(json, false);
}

export function CrmProjectDetailDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectDetailData {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'logoUrl': json['logoUrl'] === undefined ? undefined : json['logoUrl'] === null ? null : json['logoUrl'],
        'currency': json['currency'] === undefined ? undefined : json['currency'] === null ? null : json['currency'],
        'projectCreatedAt': json['projectCreatedAt'] === undefined ? undefined : json['projectCreatedAt'] === null ? null : (new Date(json['projectCreatedAt'])),
        'capturedAt': json['capturedAt'] == null ? undefined : (new Date(json['capturedAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'deletedAt': json['deletedAt'] === undefined ? undefined : json['deletedAt'] === null ? null : (new Date(json['deletedAt'])),
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'archivedAt': json['archivedAt'] === undefined ? undefined : json['archivedAt'] === null ? null : (new Date(json['archivedAt'])),
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'lifecycle': json['lifecycle'] == null ? undefined : json['lifecycle'],
        'primaryContactUserId': json['primaryContactUserId'] === undefined ? undefined : json['primaryContactUserId'] === null ? null : json['primaryContactUserId'],
        'primaryContactOrigin': json['primaryContactOrigin'] == null ? undefined : json['primaryContactOrigin'],
        'crmStatus': json['crmStatus'] == null ? undefined : json['crmStatus'],
        'nextContactAt': json['nextContactAt'] === undefined ? undefined : json['nextContactAt'] === null ? null : (new Date(json['nextContactAt'])),
        'latestNote': json['latestNote'] === undefined ? undefined : json['latestNote'] === null ? null : CrmProjectNoteDataFromJSON(json['latestNote']),
        'billing': json['billing'] === undefined ? undefined : json['billing'] === null ? null : CrmProjectBillingDataFromJSON(json['billing']),
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(CrmProjectContactDataFromJSON)),
        'integrations': json['integrations'] == null ? undefined : ((json['integrations'] as Array<any>).map(CrmProjectIntegrationDataFromJSON)),
        'subscription': json['subscription'] === undefined ? undefined : json['subscription'] === null ? null : CrmProjectSubscriptionDataFromJSON(json['subscription']),
        'subscriptionKnowledge': json['subscriptionKnowledge'] == null ? undefined : json['subscriptionKnowledge'],
        'snapshot': json['snapshot'] == null ? undefined : CrmProjectSnapshotDataFromJSON(json['snapshot']),
        'notes': json['notes'] == null ? undefined : CrmProjectNotePageDataFromJSON(json['notes']),
        'domains': json['domains'] == null ? undefined : ((json['domains'] as Array<any>).map(CrmProjectDomainDataFromJSON)),
        'domainsKnowledge': json['domainsKnowledge'] == null ? undefined : json['domainsKnowledge'],
        'pendingInvitations': json['pendingInvitations'] == null ? undefined : ((json['pendingInvitations'] as Array<any>).map(CrmProjectInvitationDataFromJSON)),
        'invitationsKnowledge': json['invitationsKnowledge'] == null ? undefined : json['invitationsKnowledge'],
    };
}

export function CrmProjectDetailDataToJSON(json: any): CrmProjectDetailData {
    return CrmProjectDetailDataToJSONTyped(json, false);
}

export function CrmProjectDetailDataToJSONTyped(value?: CrmProjectDetailData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectId': value['projectId'],
        'name': value['name'],
        'logoUrl': value['logoUrl'],
        'currency': value['currency'],
        'projectCreatedAt': value['projectCreatedAt'] == null ? value['projectCreatedAt'] : value['projectCreatedAt'].toISOString(),
        'capturedAt': value['capturedAt'] == null ? value['capturedAt'] : value['capturedAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'deletedAt': value['deletedAt'] == null ? value['deletedAt'] : value['deletedAt'].toISOString(),
        'isDeleted': value['isDeleted'],
        'archivedAt': value['archivedAt'] == null ? value['archivedAt'] : value['archivedAt'].toISOString(),
        'isArchived': value['isArchived'],
        'lifecycle': value['lifecycle'],
        'primaryContactUserId': value['primaryContactUserId'],
        'primaryContactOrigin': value['primaryContactOrigin'],
        'crmStatus': value['crmStatus'],
        'nextContactAt': value['nextContactAt'] == null ? value['nextContactAt'] : value['nextContactAt'].toISOString(),
        'latestNote': CrmProjectNoteDataToJSON(value['latestNote']),
        'billing': CrmProjectBillingDataToJSON(value['billing']),
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(CrmProjectContactDataToJSON)),
        'integrations': value['integrations'] == null ? undefined : ((value['integrations'] as Array<any>).map(CrmProjectIntegrationDataToJSON)),
        'subscription': CrmProjectSubscriptionDataToJSON(value['subscription']),
        'subscriptionKnowledge': value['subscriptionKnowledge'],
        'snapshot': CrmProjectSnapshotDataToJSON(value['snapshot']),
        'notes': CrmProjectNotePageDataToJSON(value['notes']),
        'domains': value['domains'] == null ? undefined : ((value['domains'] as Array<any>).map(CrmProjectDomainDataToJSON)),
        'domainsKnowledge': value['domainsKnowledge'],
        'pendingInvitations': value['pendingInvitations'] == null ? undefined : ((value['pendingInvitations'] as Array<any>).map(CrmProjectInvitationDataToJSON)),
        'invitationsKnowledge': value['invitationsKnowledge'],
    };
}

